<template>
  <header class="header-nav-bar">
    <div class="nav-container">

      <!-- Vùng Logo Thương hiệu -->
      <div class="logo-area">
        <router-link to="/" class="logo-link">
          <h1 class="logo-text">{{ $t('nav.logo_text') || 'Lễ hội Trái cây Đồng Tháp' }}</h1>
        </router-link>
      </div>

      <!-- Khối Menu điều hướng chính (Hỗ trợ song ngữ) -->
      <nav class="desktop-nav" :class="{ 'mobile-open': isMobileMenuOpen }">
        <router-link to="/" class="nav-item" :class="{ 'active': $route.path === '/' }" @click.native="closeMenu">
          {{ $t('nav.home') }}
        </router-link>
        <router-link to="/trai-cay/danh-sach" class="nav-item" :class="{ 'active': $route.path.includes('/trai-cay') }"
          @click.native="closeMenu">
          {{ $t('nav.products') }}
        </router-link>
        <router-link to="/lich-hoat-dong" class="nav-item"
          :class="{ 'active': $route.path.includes('/lich-hoat-dong') }" @click.native="closeMenu">
          {{ $t('nav.schedule') }}
        </router-link>
      </nav>

      <!-- Khối tác vụ bên phải (Dropdown Ngôn ngữ & Nút Hamburger mobile) -->
      <div class="right-actions">

        <!-- Cụm chọn ngôn ngữ hoàn chỉnh (Label + Dropdown) -->
        <div class="lang-selector-group">
          <!-- Tiêu đề kế Dropdown (Tự động ẩn trên mobile để tối ưu không gian) -->
          <span class="lang-switcher-label">
            {{ $t('nav.change_language') || 'Thay đổi ngôn ngữ' }}:
          </span>

          <!-- Dropdown chọn Ngôn ngữ (Language Switcher Dropdown) -->
          <div class="lang-dropdown-wrapper" ref="langDropdown">
            <button type="button" class="btn-lang-trigger" @click="toggleLangDropdown"
              :aria-expanded="isLangDropdownOpen">
              <!-- Hiển thị Lá cờ động của ngôn ngữ hiện tại -->
              <span class="current-flag-trigger">
                <img :src="currentLangFlag" class="flag-icon-img" alt="flag" />
              </span>
              <span class="current-lang-text">{{ currentLangLabel }}</span>
              <span :class="['isax isax-arrow-down-1 icon-chevron', isLangDropdownOpen ? 'rotate-up' : '']"></span>
            </button>

            <!-- Bảng chọn ngôn ngữ thả xuống (Dropdown Menu) -->
            <transition name="fade-slide">
              <div v-if="isLangDropdownOpen" class="lang-dropdown-menu">
                <button type="button" :class="['lang-option', $i18n.locale === 'vi' ? 'option-active' : '']"
                  @click="switchLanguage('vi')">
                  <div class="lang-option-content">
                    <img :src="flagVi" class="flag-icon-img" alt="vietnam" />
                    <span>Tiếng Việt (VI)</span>
                  </div>
                  <span v-if="$i18n.locale === 'vi'" class="isax isax-tick-circle tick-active"></span>
                </button>

                <button type="button" :class="['lang-option', $i18n.locale === 'en' ? 'option-active' : '']"
                  @click="switchLanguage('en')">
                  <div class="lang-option-content">
                    <img :src="flagEn" class="flag-icon-img" alt="english" />
                    <span>English (EN)</span>
                  </div>
                  <span v-if="$i18n.locale === 'en'" class="isax isax-tick-circle tick-active"></span>
                </button>
              </div>
            </transition>
          </div>
        </div>

        <!-- Nút Menu thu gọn trên di động -->
        <button type="button" class="mobile-menu-btn" @click="isMobileMenuOpen = !isMobileMenuOpen">
          <span class="isax isax-menu-1 icon-hamburger"></span>
        </button>
      </div>

    </div>
  </header>
</template>

<script>
import flagVi from "@/assets/images/small/vietnam.png";
import flagEn from "@/assets/images/small/united_kingdom.png";

export default {
  name: "HeaderNavBar",
  data() {
    return {
      isMobileMenuOpen: false,
      isLangDropdownOpen: false,
      flagVi,
      flagEn
    };
  },
  computed: {
    // Nhãn ngôn ngữ hiện tại để hiển thị trên nút Trigger
    currentLangLabel() {
      const currentLocale = this.$i18n ? this.$i18n.locale : 'vi';
      return currentLocale === 'en' ? 'EN' : 'VI';
    },
    // Trả về Lá cờ của ngôn ngữ hiện tại để hiển thị trực quan lên Trigger
    currentLangFlag() {
      const currentLocale = this.$i18n ? this.$i18n.locale : 'vi';
      return currentLocale === 'en' ? this.flagEn : this.flagVi;
    }
  },
  mounted() {
    // Đăng ký sự kiện click toàn cục để tự động đóng dropdown khi click ra ngoài
    document.addEventListener("click", this.handleClickOutside);
  },
  destroyed() {
    // Giải phóng bộ nhớ sự kiện click toàn cục
    document.removeEventListener("click", this.handleClickOutside);
  },
  methods: {
    closeMenu() {
      this.isMobileMenuOpen = false;
    },
    toggleLangDropdown() {
      this.isLangDropdownOpen = !this.isLangDropdownOpen;
    },
    switchLanguage(locale) {
      if (this.$i18n) {
        this.$i18n.locale = locale;
      }
      localStorage.setItem('user-locale', locale);
      this.isLangDropdownOpen = false; // Thu gọn dropdown sau khi chọn xong
    },
    // Hàm xử lý đóng dropdown khi nhấp ngoài vùng chọn
    handleClickOutside(event) {
      const dropdown = this.$refs.langDropdown;
      if (dropdown && !dropdown.contains(event.target)) {
        this.isLangDropdownOpen = false;
      }
    }
  }
};
</script>

<style scoped>
/* ======================== NAVBAR मास्टर डिजाइन ======================== */
.header-nav-bar {
  background-color: var(--surface, #ffffff);
  border-bottom: 1px solid var(--surface-dim, #d7dbd2);
  width: 100%;
  z-index: 100;
  position: sticky;
  top: 0;
}

.nav-container {
  max-width: var(--container-max, 1280px);
  margin: 0 auto;
  padding: 0 var(--spacing-gutter, 24px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
}

.logo-link {
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
}

.logo-text {
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: var(--primary, #0d631b);
  margin: 0;
}

.desktop-nav {
  display: flex;
  gap: 32px;
}

.nav-item {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: var(--on-surface-variant, #40493d);
  text-decoration: none;
  transition: color 0.25s;
  padding-bottom: 4px;
}

.nav-item.active {
  color: var(--primary, #0d631b);
  font-weight: 700;
  border-bottom: 2px solid var(--primary, #0d631b);
}

.nav-item:hover {
  color: var(--primary, #0d631b);
  text-decoration: none;
}

.right-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* ======================== CỤM ĐIỀU HƯỚNG NGÔN NGỮ ======================== */
.lang-selector-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.lang-switcher-label {
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: var(--on-surface-variant, #40493d);
}

@media (max-width: 991px) {

  /* Ẩn tiêu đề chữ trên tablet/mobile để giữ giao diện tinh gọn */
  .lang-switcher-label {
    display: none;
  }
}

/* ======================== DROPDOWN NGÔN NGỮ CAO CẤP ======================== */
.lang-dropdown-wrapper {
  position: relative;
  display: inline-block;
  font-family: var(--font-body, "Inter"), sans-serif;
}

.btn-lang-trigger {
  background-color: var(--surface-container-low, #f1f5eb);
  border: 1px solid var(--outline-variant, #bfcaba);
  padding: 8px 14px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--on-surface-variant, #40493d);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;
  outline: none;
}

.btn-lang-trigger:hover {
  border-color: var(--primary, #0d631b);
  color: var(--primary, #0d631b);
}

.current-flag-trigger {
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
}

.flag-icon-img {
  width: 20px;
  height: 14px;
  object-fit: cover;
  border-radius: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
  display: block;
}

.lang-option-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.current-lang-text {
  font-size: 12px;
  letter-spacing: 0.05em;
}

.icon-chevron {
  font-size: 12px;
  transition: transform 0.2s ease;
}

.icon-chevron.rotate-up {
  transform: rotate(180deg);
}

/* Bảng menu thả xuống */
.lang-dropdown-menu {
  position: absolute;
  top: 110%;
  right: 0;
  background-color: #ffffff;
  border: 1px solid rgba(187, 202, 186, 0.4);
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  width: 170px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  z-index: 110;
}

.lang-option {
  width: 100%;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 8px;
  text-align: left;
  font-size: 13px;
  font-weight: 600;
  color: var(--on-surface-variant, #40493d);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.15s ease;
  outline: none;
}

.lang-option:hover {
  background-color: var(--surface-container-low, #f1f5eb);
  color: var(--primary, #0d631b);
}

.lang-option.option-active {
  background-color: rgba(13, 99, 27, 0.08);
  color: var(--primary, #0d631b);
}

.lang-flag-icon {
  margin-right: 6px;
  font-size: 14px;
}

.tick-active {
  font-size: 16px;
  color: var(--primary, #0d631b);
}

/* ======================== MOBILE NAVIGATION RESPONSIVE ======================== */
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  cursor: pointer;
  color: var(--on-surface-variant, #40493d);
  padding: 4px;
  outline: none;
}

.icon-hamburger {
  font-size: 24px;
}

@media (max-width: 768px) {
  .desktop-nav {
    display: none;
    flex-direction: column;
    position: absolute;
    top: 64px;
    left: 0;
    width: 100%;
    background-color: var(--surface, #ffffff);
    padding: 16px var(--spacing-gutter, 24px);
    border-bottom: 1px solid var(--surface-dim, #d7dbd2);
    box-shadow: 0 10px 15px rgba(0, 0, 0, 0.04);
    gap: 16px;
  }

  .desktop-nav.mobile-open {
    display: flex;
  }

  .mobile-menu-btn {
    display: block;
  }

  .logo-text {
    font-size: 16px;
  }
}

/* ======================== TRANSITIONS ANIMATION ======================== */
.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.fade-slide-enter,
.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
</style>